export enum BuyerLinkOutcome {
    Linked = 0,
    ReEngaged = 1,
    AlreadyActive = 2,
    WaitingForTheirGate = 3,
}
